<script setup lang="ts">
const props = withDefaults(defineProps<{
    link?: string;
    linkType?: "router" | "anchor";
}>(), {
    link: "/",
    linkType: "router",
});
</script>
<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <br>
                <h2 class="text-xl text-center">
                    Something went wrong
                </h2>
                <p
                    v-if="props.linkType === 'router'"
                    class="text-center"
                >
                    Could not load the quotes,
                    <router-link

                        class="underline"
                        :to="props.link"
                    >
                        please click here to start again
                    </router-link>
                    .
                </p>
                <p
                    v-else
                    class="text-center"
                >
                    Could not load the quotes,
                    <a
                        class="underline"
                        :href="props.link"
                    >
                        please click here to start again
                    </a>
                    .
                </p>
            </div>
        </div>
    </div>
</template>
